var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxCheckCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 1.66602C5.4024 1.66602 1.66406 5.40435 1.66406 9.99935C1.66406 14.5943 5.4024 18.3327 9.9974 18.3327C14.5924 18.3327 18.3307 14.5943 18.3307 9.99935C18.3307 5.40435 14.5924 1.66602 9.9974 1.66602ZM9.9974 16.666C6.32156 16.666 3.33073 13.6752 3.33073 9.99935C3.33073 6.32352 6.32156 3.33268 9.9974 3.33268C13.6732 3.33268 16.6641 6.32352 16.6641 9.99935C16.6641 13.6752 13.6732 16.666 9.9974 16.666Z",
    fill: "#74788D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33469 11.3218L6.41885 9.40932L5.24219 10.5893L8.33635 13.6768L13.9247 8.08849L12.7464 6.91016L8.33469 11.3218Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCheckCircle);
export default __webpack_public_path__ + "static/media/bx-check-circle.bd0cd918d2123e907cb53ae17fa9ee63.svg";
export { ForwardRef as ReactComponent };